export default "__VITE_ASSET__DcOdv5Vn__"